<template>
  <div class="overflow-y-scroll">
    <section>
      <div class="form-inline">
        <label>Reason:</label>
        <div>
          <quill-editor
            name="Reason"
            :options="editorOption"
            :content="editReason"
            v-model="editReason"
          />
        </div>
      </div>
      <div class="form-inline flex-row m-t-l">
        <spinnerButton class="submit primary" @click.native="buttonClick"
          >Submit</spinnerButton
        >
      </div>
    </section>
  </div>
</template>

<script>
import spinnerButton from "@/components/public/SpinnerButton";

export default {
  props: ["reason"],
  components: {
    spinnerButton,
  },
  data() {
    return {
      editReason: "",
      editorOption: {
        modules: {
          toolbar: [
            ["link", "bold", "italic", { list: "ordered" }, { list: "bullet" }],
          ],
        },
        theme: "snow",
      },
    };
  },
  mounted() {
    this.editReason = this.reason;
  },
  methods: {
    buttonClick: function () {
      this.$emit("updateRejectedReason", this.editReason);
    },
  },
};
</script>
